import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const InstagramSettings = () => {
  const [accessToken, setAccessToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSaveSettings = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!accessToken) {
      toast({
        title: "Erro",
        description: "Por favor, insira o token de acesso do Instagram",
        variant: "destructive",
      });
      return;
    }

    setIsLoading(true);

    try {
      const { error } = await supabase
        .from('instagram_settings')
        .upsert({ 
          access_token: accessToken,
        });

      if (error) {
        console.error("Erro Supabase:", error);
        throw error;
      }

      toast({
        title: "Sucesso",
        description: "Configurações do Instagram salvas com sucesso",
      });
      
      // Limpar o campo após salvar com sucesso
      setAccessToken("");
    } catch (error) {
      console.error("Erro ao salvar configurações:", error);
      toast({
        title: "Erro",
        description: "Falha ao salvar as configurações do Instagram. Por favor, tente novamente.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSaveSettings} className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="accessToken" className="text-sm font-medium">
          Token de Acesso
        </label>
        <Input
          id="accessToken"
          type="password"
          placeholder="Cole aqui seu token de acesso do Instagram"
          value={accessToken}
          onChange={(e) => setAccessToken(e.target.value)}
          disabled={isLoading}
        />
      </div>
      <Button type="submit" disabled={isLoading} className="w-full">
        {isLoading ? "Salvando..." : "Salvar Configurações"}
      </Button>
    </form>
  );
};